var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.4458 40.8461C71.4458 57.6608 57.8148 71.2919 41 71.2919C24.1853 71.2919 10.5542 57.6608 10.5542 40.8461C10.5542 24.0313 24.1853 10.4003 41 10.4003C45.7768 10.4003 50.2966 11.5003 54.32 13.461M65.7372 21.8174L39.0971 48.4575L31.4857 40.8461",
    stroke: "#825DFC",
    strokeWidth: 6.76573,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4e6e0b2cd1c69462004774f35f7b07e3.svg";
export { ForwardRef as ReactComponent };